// src/pages/ContactUs.js
import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    // You can add your form submission logic here
  };

  return (
    <div>
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative py-20 overflow-hidden bg-gradient-to-br from-yellow-500 via-green-700 to-gray-900">
        {/* Background Decorative Elements */}
        <div className="absolute w-32 h-32 bg-white rounded-full top-10 left-10 opacity-10 animate-pulse"></div>
        <div className="absolute w-48 h-48 bg-yellow-500 rounded-full bottom-10 right-10 opacity-10 animate-pulse"></div>
        
        <div className="relative z-10 max-w-6xl px-6 mx-auto text-center text-white">
          <h1 className="mb-4 text-5xl font-extrabold tracking-tight uppercase md:text-7xl">
            Contact <span className="text-yellow-500">Shinpex Academy</span>
          </h1>
          <div className="w-24 h-1 mx-auto mb-6 bg-yellow-500"></div>
          <p className="max-w-3xl mx-auto text-xl font-medium md:text-2xl">
            Ready to join Africa's premier educational institution? We're here to help you take the next step.
          </p>
        </div>
      </section>

      <section className="py-16 bg-gray-100">
        <div className="px-6 mx-auto max-w-7xl">
          
          {/* Contact Cards Grid */}
          <div className="grid grid-cols-1 gap-8 mb-16 md:grid-cols-3">
            
            {/* Contact Information Card */}
            <div className="p-8 transition-all duration-300 transform shadow-xl bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-2xl hover:scale-105">
              <div className="text-center">
                <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-black rounded-full">
                  <svg className="w-8 h-8 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                  </svg>
                </div>
                <h3 className="mb-4 text-2xl font-bold text-black uppercase">Contact Info</h3>
                <div className="space-y-3 text-gray-900">
                  <p><strong>Email:</strong><br />support@shinpexacademy.com</p>
                  <p><strong>Phone:</strong><br />+234 8164230695</p>
                  <p><strong>Address:</strong><br />Ilorin, Kwara State<br />Nigeria</p>
                </div>
              </div>
            </div>

            {/* Office Hours Card */}
            <div className="p-8 transition-all duration-300 transform shadow-xl bg-gradient-to-br from-green-700 to-green-800 rounded-2xl hover:scale-105">
              <div className="text-center">
                <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-white rounded-full bg-opacity-20">
                  <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                  </svg>
                </div>
                <h3 className="mb-4 text-2xl font-bold text-white uppercase">Office Hours</h3>
                <div className="space-y-3 text-gray-100">
                  <p><strong>Monday - Friday:</strong><br />8:00 AM - 5:00 PM</p>
                  <p><strong>Saturday:</strong><br />9:00 AM - 2:00 PM</p>
                  <p><strong>Sunday:</strong><br />Closed</p>
                </div>
              </div>
            </div>

            {/* Quick Links Card */}
            <div className="p-8 transition-all duration-300 transform shadow-xl bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl hover:scale-105">
              <div className="text-center">
                <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-yellow-500 rounded-full bg-opacity-20">
                  <svg className="w-8 h-8 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z" clipRule="evenodd" />
                  </svg>
                </div>
                <h3 className="mb-4 text-2xl font-bold text-white uppercase">Quick Links</h3>
                <div className="space-y-3">
                  <a href="#admissions" className="block font-medium text-yellow-500 transition-colors hover:text-yellow-400">
                    → Admissions Process
                  </a>
                  <a href="#programs" className="block font-medium text-yellow-500 transition-colors hover:text-yellow-400">
                    → Academic Programs
                  </a>
                  <a href="#scholarships" className="block font-medium text-yellow-500 transition-colors hover:text-yellow-400">
                    → Scholarships
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="p-8 bg-white shadow-2xl rounded-2xl md:p-12">
            <div className="mb-10 text-center">
              <h2 className="mb-4 text-4xl font-bold text-gray-900 uppercase">
                Get In <span className="text-yellow-500">Touch</span>
              </h2>
              <div className="w-16 h-1 mx-auto mb-4 bg-yellow-500"></div>
              <p className="max-w-2xl mx-auto text-xl text-gray-600">
                Ready to embark on an educational journey that will shape your future? Send us a message and let's discuss how Shinpex Academy can help you achieve your dreams.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="max-w-4xl mx-auto">
              <div className="grid grid-cols-1 gap-6 mb-6 md:grid-cols-2">
                <div>
                  <label htmlFor="name" className="block mb-2 font-semibold tracking-wide text-gray-700 uppercase">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full p-4 transition-colors duration-300 border-2 border-gray-300 rounded-xl focus:border-yellow-500 focus:outline-none"
                    placeholder="Enter your full name"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block mb-2 font-semibold tracking-wide text-gray-700 uppercase">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full p-4 transition-colors duration-300 border-2 border-gray-300 rounded-xl focus:border-yellow-500 focus:outline-none"
                    placeholder="Enter your email"
                    required
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 gap-6 mb-6 md:grid-cols-2">
                <div>
                  <label htmlFor="phone" className="block mb-2 font-semibold tracking-wide text-gray-700 uppercase">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full p-4 transition-colors duration-300 border-2 border-gray-300 rounded-xl focus:border-yellow-500 focus:outline-none"
                    placeholder="Enter your phone number"
                  />
                </div>
                <div>
                  <label htmlFor="subject" className="block mb-2 font-semibold tracking-wide text-gray-700 uppercase">
                    Subject *
                  </label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className="w-full p-4 transition-colors duration-300 border-2 border-gray-300 rounded-xl focus:border-yellow-500 focus:outline-none"
                    required
                  >
                    <option value="">Select a subject</option>
                    <option value="admissions">Admissions Inquiry</option>
                    <option value="programs">Academic Programs</option>
                    <option value="scholarships">Scholarships</option>
                    <option value="general">General Information</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>

              <div className="mb-8">
                <label htmlFor="message" className="block mb-2 font-semibold tracking-wide text-gray-700 uppercase">
                  Message *
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="6"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full p-4 transition-colors duration-300 border-2 border-gray-300 resize-none rounded-xl focus:border-yellow-500 focus:outline-none"
                  placeholder="Tell us how we can help you..."
                  required
                ></textarea>
              </div>

              <div className="text-center">
                <button
                  type="submit"
                  className="px-12 py-4 text-lg font-bold tracking-wider text-black uppercase transition-all duration-300 transform rounded-full shadow-xl bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 hover:scale-105"
                >
                  Send Message
                </button>
              </div>
            </form>
          </div>

          {/* Call to Action */}
          <div className="p-12 mt-16 text-center bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl">
            <h3 className="mb-4 text-3xl font-bold text-white uppercase">
              Ready to Join <span className="text-yellow-500">Shinpex Academy</span>?
            </h3>
            <p className="max-w-2xl mx-auto mb-6 text-xl text-gray-300">
              Take the first step towards academic excellence and innovation. Our admissions team is ready to guide you through the process.
            </p>
            <button className="px-8 py-3 font-bold tracking-wide text-white uppercase transition-all duration-300 transform rounded-full shadow-lg bg-gradient-to-r from-green-700 to-green-800 hover:from-green-800 hover:to-green-900 hover:scale-105">
              Apply Now
            </button>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default ContactUs;